export enum RightsholderRestrictionStatus {
    NONE = 'NONE',
    FRAUD = 'FRAUD',
}
